import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import { amplifyConfig } from './config/amplify';
import './index.css';

// Configure AWS Amplify
Amplify.configure(amplifyConfig);

// Provider composition (Requirement 17.4):
//   AuthProvider → IdleTimeoutManager → BrandingProvider → BrowserRouter
// Dark theme dropped in PR (m.0); ThemeProvider removed accordingly.
// All remaining providers and the router live in App.tsx.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
